const urlSearch = typeof window !== 'undefined' ? window?.location?.search.toLowerCase() : '';
const searchParams = new URLSearchParams(urlSearch);
const isPreviewProduct = Boolean(searchParams.get('previewid'));
export default isPreviewProduct;
